/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Kronberg_Gymnasium2Inputs */

const en__field_enum_kronberg_gymnasium2 = /** @type {(inputs: _Field_Enum_Kronberg_Gymnasium2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aschaffenburg`)
};

const de__field_enum_kronberg_gymnasium2 = /** @type {(inputs: _Field_Enum_Kronberg_Gymnasium2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kronberg-Gymnasium`)
};

/**
* | output |
* | --- |
* | "Aschaffenburg" |
*
* @param {_Field_Enum_Kronberg_Gymnasium2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_kronberg_gymnasium2 = /** @type {((inputs?: _Field_Enum_Kronberg_Gymnasium2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Kronberg_Gymnasium2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_kronberg_gymnasium2(inputs)
	return de__field_enum_kronberg_gymnasium2(inputs)
});
export { _field_enum_kronberg_gymnasium2 as "_field_enum_Kronberg_Gymnasium" }